import { IComment } from '@signing-page/chat/types/comment';
import { IChatParticipant } from '@signing-page/chat/types/chat-participant';
import { translate } from '@/helpers/translation.helper';
import { IRecipient } from '@signing-page/documents/types/recipient';
import { IUser } from '@signing-page/users/types/user';

export class ChatHelper {
  static getChatParticipants(
    sender: IUser,
    recipients: IRecipient[],
    recipientId: string
  ): IChatParticipant[] {
    const participants: IChatParticipant[] = [];

    if (!recipients.length) {
      return participants;
    }

    recipients.forEach((recipient: IRecipient) => {
      const isMe = recipient.id === recipientId;
      const participant: IChatParticipant = {
        fullName: isMe ? translate('you') : this.getFullName(recipient),
        email: recipient.email,
        thumbUrl: recipient.thumbUrl,
      };
      if (isMe) {
        participants.splice(0, 0, participant);
      } else {
        participants.push(participant);
      }
    });

    participants.splice(1, 0, {
      fullName: this.getFullName(sender),
      email: sender.email,
      thumbUrl: sender.thumbUrl,
    });

    return participants;
  }

  static getFullName(person: IUser | IRecipient): string {
    if (!person) {
      return '';
    }
    if (person.fullName) {
      return person.fullName;
    }
    if (person.firstName || person.lastName) {
      return `${person.firstName || ''} ${person.lastName || ''}`;
    }
    return '';
  }

  static isByMe(comment: IComment, me: string): boolean {
    return comment.recipientId === me;
  }

  static addPunctuationMark(index: number, length: number): string {
    if (index < length - 2) {
      return ',';
    }
    if (index === length - 2) {
      return ' &';
    }
    return '';
  }

  static getPreviousComment(comment: IComment, comments: IComment[]): IComment {
    const index: number = comments.indexOf(comment) - 1;
    return comments[index];
  }

  static getNextComment(comment: IComment, comments: IComment[]): IComment {
    const index: number = comments.indexOf(comment) + 1;
    return comments[index];
  }

  static getLastComment(comments: IComment[]) {
    return comments[comments.length - 1];
  }

  static getThumbUrl(person: IRecipient | IUser): string {
    return person.thumbUrl || '';
  }

  static getDate(timestamp: string, at: string): string {
    return timestamp.slice(0, timestamp.indexOf(at));
  }

  static getTime(timestamp: string, at: string): string {
    return timestamp.slice(timestamp.indexOf(at));
  }
}
